import { render, staticRenderFns } from "./resource-action.vue?vue&type=template&id=a0b8cf9c"
import script from "./resource-action.vue?vue&type=script&lang=js"
export * from "./resource-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports